import { OBJECT } from '../types';

/**
 * Checks if the schema is set to type object.
 * @param {Object} schema
 */
const hasTopLevelObject = schema => {
  return schema.type === OBJECT;
};

/** Rules to be checked by the validator */
const rules = [
  {
    details: 'The top-level type should be an object.',
    validate: hasTopLevelObject,
  },

  /* TODO Add more validation rules */
];

/**
 * Checks if the given schema can be understood by Ellington.
 * At the moment, this is not a deep validation of the schema and only checks if
 * the basic structure at the top-level can be understood by the generator.
 * The rules can be expanded in future releases to build towards deep validation.
 * @param {Object} schema
 */
const isValidEllingtonSchema = (schema = {}) => {
  const results = [];

  rules.forEach(rule => {
    if (rule.validate(schema)) {
      return;
    }
    results.push(schema);
  });

  return results.length === 0;
};

export default isValidEllingtonSchema;
